import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MenuComponent } from '../MenuComponent';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import * as MySound from '../MySound';

export class LH_Rows extends Component {
    static displayName = LH_Rows.name;

    constructor(props) {

        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            containerRows: [],
            selectedContainerRef:"",
            selectedSSCC: "",
            selectedDebtor: "",
            selectedPutawayloc: "",
            selectedCartonType: "",
            scannedSSCC: "",
            scannedDebtor: "",
            scannedPutawayloc: "",
            scannedCartonType: ""
        }
    }

    componentDidMount() {
        if (this.props.location && this.props.location.state) {
            this.state.selectedContainerRef = this.props.location.state.selectedContainerRef;
            this.loadRows();
        }
        this.refs.ssccBarcodeInput.focus();

    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    async loadRows() {
        this.state.loading = true;


        fetch(`api/LinenhouseXdoc/GetRows?containerRef=${this.state.selectedContainerRef}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ containerRows: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (!data || data.length <= 0) {
                                this.setState({ alertMessage: "No data found!!" });
                                this.goto('../LinenhouseXdoc/LH_LoadOpenASN');
                            }
                            else {
                              this.setState({ containerRows: data, alertMessage: "" });
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Rows!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Rows!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ containerRows: [], alertMessage: error });
            });
    }

    validateBarcode() {
        this.setState({ alertMessage: "" });
        if (!this.state.scannedSSCC || this.state.scannedSSCC == "") {
            this.resetSSCCBarcodeInput("Please scan a valid bardcode");
            return;
        }
        const matchingSSCCBarcode = this.state.containerRows.find((containerRow) => {
            return containerRow.sscc.trim().toUpperCase() === this.state.scannedSSCC.trim().toUpperCase();
        });
        if (!matchingSSCCBarcode) {
            this.resetSSCCBarcodeInput("Wrong SSCC Put carton Back!!");
            return;
        }

        this.state.scannedDebtor = matchingSSCCBarcode.debtor.trim();
        this.state.scannedPutawayloc = matchingSSCCBarcode.putawayloc.trim();
        this.state.scannedCartonType = matchingSSCCBarcode.cartonType.trim();

        MySound.play(MySound.Sound.next);
        this.goto('../LinenhouseXdoc/LH_Pallet');

    }
    resetSSCCBarcodeInput(errorMessage) {
         MySound.play(MySound.Sound.stop);
         this.setState({ scannedSSCC: "", alertMessage: errorMessage });
         this.refs.ssccBarcodeInput.focus();
      }

    render() {

        let rowsHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderRows();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const handlebarcodeKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateBarcode();
            }
        };
        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Cartons for Container No. {this.state.selectedContainerRef}</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../LinenhouseXdoc/LH_LoadOpenASN'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <input ref="ssccBarcodeInput" className="form-control" placeholder="SSCCBarcode" value={this.state.scannedSSCC}
                                onChange={(e) => {
                                    this.setState({ scannedSSCC: e.target.value });
                                }} onKeyPress={handlebarcodeKeyPress} readOnly={this.state.loading} >
                            </input>


                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {rowsHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

    renderRows() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>SSCC</label>
                                <br />
                                <input ref="ssccInput" value={this.state.selectedSSCC} onChange={(e) => { this.setState({ selectedSSCC: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Debtor</label>
                                <br />
                                <input ref="debtorInput" value={this.state.selectedDebtor} onChange={(e) => { this.setState({ selectedDebtor: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Put away loc</label>
                                <br />
                                <input ref="putawaylocInput" value={this.state.selectedPutawayloc} onChange={(e) => { this.setState({ selectedPutawayloc: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Carton Type</label>
                                <br />
                                <input  ref="cartonTypeInput" value={this.state.selectedCartonType} onChange={(e) => { this.setState({ selectedCartonType: e.target.value }); }} />
                            </th>


                        </tr>
                    </thead>
                    <tbody>
                        {this.state.containerRows.filter((item) =>

                           (!this.state.selectedSSCC.length ||
                                item.sscc
                                    .toString()
                                    .toLowerCase()
                                    .includes(this.state.selectedSSCC.toString().toLowerCase())) &&
                            (!this.state.selectedDebtor.length ||
                                item.debtor
                                    .toString()
                                    .toLowerCase()
                                    .includes(this.state.selectedDebtor.toString().toLowerCase())) &&
                            (!this.state.selectedPutawayloc.length ||
                                item.putawayloc
                                    .toString()
                                    .toLowerCase()
                                .includes(this.state.selectedPutawayloc.toString().toLowerCase())) &&
                            (!this.state.selectedCartonType.length ||
                                item.cartonType
                                    .toString()
                                    .toLowerCase()
                                .includes(this.state.selectedCartonType.toString().toLowerCase()))
                            ).map(row =>
                                        <tr key={row.sscc}>
                                            <td>{row.sscc}</td>
                                            <td>{row.debtor}</td>
                                            <td>{row.putawayloc}</td>
                                            <td>{row.cartonType}</td>
                                        </tr>
                                    )}
                    </tbody>
                </table>
            </div>
        );
    }

}
